import { AppLogo } from '@/components/common/AppLogo';
import { formatDisplayDate } from '@/utils/date';
import type { PcmpPerformanceReport } from '../../types/pcmpReports.types';
import { PcmpPerformanceReportTable } from './PcmpPerformanceReportTable';

interface PcmpPerformanceReportSheetProps {
  report: PcmpPerformanceReport;
}

/** The Performance report as printed: heading, the period it covers, then the table. */
export function PcmpPerformanceReportSheet({ report }: PcmpPerformanceReportSheetProps) {
  const { highest, lowest } = report;

  return (
    <div className="flex flex-col gap-2 text-neutral-900">
      <div className="flex items-center justify-between gap-4">
        <AppLogo className="size-9" />
        <div className="text-right">
          <h1 className="text-base font-bold">PCMP Performance Report</h1>
          <p className="text-xs text-neutral-600">{report.periodLabel}</p>
          <p className="text-xs text-neutral-600">As of {formatDisplayDate(report.reportDate)}</p>
        </div>
      </div>
      {highest || lowest ? (
        <p className="text-xs">
          {highest ? `Highest: ${highest.label} (${highest.subtotal.cmpPercent.toFixed(2)}%)` : ''}
          {highest && lowest ? ' · ' : ''}
          {lowest ? `Lowest: ${lowest.label} (${lowest.subtotal.cmpPercent.toFixed(2)}%)` : ''}
        </p>
      ) : null}
      <PcmpPerformanceReportTable report={report} />
    </div>
  );
}
